import omit from 'lodash/omit';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const loadStatusCountQueryAtom = createQueryAtomFactory(
  'trade.loadsCountingByStatus',
  () => ({
    loadStatusCounts: {
      pending: true,
      reconciled: true,
      received: true,
      shipped: true,
      unassigned: true,
      voided: true,
      containerAtPort: true,
      containerInTransit: true,
      containerAtFacility: true,
      containerLoaded: true,
      containerReturning: true,
      containerReadyToShip: true,
    },
  }),
  {
    select: ({ loadStatusCounts }) => omit(loadStatusCounts, ['__typename']),
  },
);
